export function useMaintenanceBanner({
  maintenancePeriodStartDate,
  maintenancePeriodEndDate,
}) {
  const now = new Date()

  // Validate that maintenancePeriodStartDate & maintenancePeriodEndDate are valid dates
  const isValidMaintenancePeriod =
    maintenancePeriodStartDate instanceof Date &&
    !isNaN(maintenancePeriodStartDate) &&
    maintenancePeriodEndDate instanceof Date &&
    !isNaN(maintenancePeriodEndDate)

  const isWithinMaintenanceWindow =
    isValidMaintenancePeriod &&
    maintenancePeriodStartDate < now &&
    maintenancePeriodEndDate > now

  const maintenanceWarningPeriod = 1000 * 60 * 60 // 1 hour

  const isWithinMaintenanceWarningPeriod =
    !isWithinMaintenanceWindow &&
    isValidMaintenancePeriod &&
    now > maintenancePeriodStartDate - maintenanceWarningPeriod &&
    now < maintenancePeriodStartDate

  const shouldShowMaintenanceBanner =
    isWithinMaintenanceWarningPeriod || isWithinMaintenanceWindow

  return {
    isWithinMaintenanceWindow,
    isWithinMaintenanceWarningPeriod,
    shouldShowMaintenanceBanner,
    isValidMaintenancePeriod,
  }
}
